import React from "react";
import "./header.css"

class Header extends React.Component {
    render() {
        return <div className="header">Tic Tac Toe</div>
    }
}

export default Header;